import { Button, EmptyState, EmptyStateBody, Page, Title } from '@patternfly/react-core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './logged-out-page.css';
import logo70b from '../../img/mvision-title-black-70.png';

const LoggedOutPage = () => {
    const {t} = useTranslation();

    return (
        <Page>
            <EmptyState>
                <div className="logged-out-logo">
                    <img src={logo70b} alt="MVision logo" />
                </div>

                <Title headingLevel="h4" size="lg">{t('loggedOutPage.title')}</Title>
                <EmptyStateBody>{t('loggedOutPage.body', { appName: t('appTitle') })}</EmptyStateBody>
                <Button component="a" variant="primary" href="./">{t('loggedOutPage.action')}</Button>
            </EmptyState>
        </Page >

    );
}

export default LoggedOutPage;
